<template>
    <not-found-view v-if="error" :error500="true"></not-found-view>

    <div v-else class="grid grid--padding">
        <div class="budget budget--overview">
            <overview-layout :items="savedMaterials">
                <template #header>
                    <h2 class="budget__title">{{ $t('game-overview.title') }}</h2>
                </template>

                <template #footer>
                    <ul class="price-list">
                        <li class="price-list__item">
                            <span>{{ $t('game.text.initial-budget') }}</span>
                            <span>{{ formatValueWithUnit(initialBudget, null) }}</span>
                        </li>
                        <li class="price-list__item">
                            <span>{{ $t('game.text.spent-budget') }}</span>
                            <span>{{ formatValueWithUnit(spentBudget, null) }}</span>
                        </li>
                        <li class="price-list__item price-list__item--highlighted">
                            <span>{{ $t('game.text.remaining-budget') }}</span>
                            <span class="price-list__price">{{ formatValueWithUnit(remainingBudget, null) }}</span>
                        </li>
                    </ul>

                    <button @click="openHouseModel" class="btn btn--secondary">
                        {{ $t('button.check-your-house') }}
                    </button>

                    <h3 class="budget__subtitle">{{ $t('game-options.overview.text') }}</h3>

                    <div class="budget__actions">
                        <router-link :to="{name: 'game-leaderboard'}" :class="['btn btn--primary', {'disabled': disableFinishGameButton()}]">
                            {{ $t('button.confirm-selected') }}
                        </router-link>
                        <button @click="resetGameMaterials" class="btn btn--secondary">
                            {{ $t('button.change-all') }}
                        </button>
                    </div>
                </template>
            </overview-layout>
        </div>
    </div>
</template>

<script>
import { makeBuildReport } from '@/queries/buildReportQueries.js';
import OverviewLayout from '@/components/game/OverviewLayout.vue';

export default {
    name: 'GameOverviewView',
    components: {
        OverviewLayout
    },
    inject: ['formatValueWithUnit'],
    emits: ['open-model'],
    data() {
        return {
            error: false
        }
    },
    computed: {
        savedOptions() {
            return this.$store.getters['game/getSavedOptions'];
        },
        savedMaterials() {
            return this.$store.getters['game/getSavedMaterials'];
        },
        savedMaterialsIds() {
            return this.$store.getters['game/getSavedMaterialsIds'];
        },
        householdMembers() {
            return this.$store.getters['game/getHouseholdMembers'];
        },
        surfaceArea() {
            return this.$store.getters['game/getSurfaceArea'];
        },
        location() {
            return this.$store.getters['game/getLocation'];
        },
        budgetCurrency() {
            return this.$store.getters['game/getBudgetCurrency'];
        },
        initialBudget() {
            return this.$store.getters['game/getInitalBudgetAmout'];
        },
        budgetAmount() {
            return this.$store.getters['game/getBudgetAmount'];
        },
        spentBudget() {
            let spent = parseInt(this.initialBudget) - parseInt(this.budgetAmount);

            return spent;
        },
        remainingBudget() {
            return this.initialBudget - this.spentBudget;
        },
        vectaryModel() {
            return this.$store.getters['game/getVectaryModel'];
        },
    },
    methods: {
        resetGameMaterials() {
            this.$store.dispatch('game/resetGameMaterials');
        },
        openHouseModel() {
            this.$emit('open-model');
        },
        disableFinishGameButton() {
            let disabledButton = false;
            let disabledPhases = [];

            this.savedMaterials.forEach(phase => {
                if (phase.disabledByMaterial) {
                    phase.disabledByMaterial.forEach(material => {
                        if (this.savedMaterialsIds.includes(material.id)) {
                            disabledPhases.push(phase.id);
                        }
                    });
                }
            });

            this.savedMaterials.forEach(phase => {
                if (!disabledPhases.includes(phase.id) && !phase.data.length) {
                    disabledButton = true;
                }
            });

            return disabledButton;
        },
        async saveModelScreenshot() {
            try {
                await this.vectaryModel.takeScreenshot().then((res) => {
                    this.$store.commit('game/updateVectaryModelScreenshot', res);
                }).catch((error) => {
                    console.error(error);
                });
            } catch (e) {
                console.log(e);
            }
        }
    },
    beforeRouteLeave(to, _from, next) {
        const phase = this.savedMaterials.findIndex(material => material.id == to.params.phaseId);

        if (to.name == 'game-menu') {
            this.$store.commit('game/updatePhase', phase);
            next();
        } else if (to.name == 'game-leaderboard') {
            this.saveModelScreenshot();

            this.$apollo.mutate({
                mutation: makeBuildReport,
                variables: {
                    materials: this.savedMaterialsIds,
                    householdMembers: parseInt(this.householdMembers),
                    surfaceArea: parseInt(this.surfaceArea),
                    budget: parseInt(this.initialBudget),
                    region: parseInt(this.location)
                }
            }).then((res) => {
                this.$store.commit('game/saveResultId', res.data.makeBuildReport.id);
            }).then(() => {
                next();
            }).catch((error) => {
                console.error(error);
                this.error = true;
            });
        } else {
            next();
        }
    }
}
</script>
